import React from 'react';
import { mockProperties } from '../data/mock';
import { useTranslation } from '../hooks/useTranslation';

const Properties = () => {
  const { t } = useTranslation();
  
  return (
    <section id="properties" className="section-padding" style={{ background: '#fffef2' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6">{t.properties.title}</h2>
          <div className="w-20 h-px bg-gray-300 mx-auto mb-6"></div>
          <p className="body-regular" style={{ color: '#666666', maxWidth: '700px', margin: '0 auto' }}>
            {t.properties.subtitle}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {mockProperties.map((property) => (
            <div
              key={property.id}
              className="group cursor-pointer transition-all duration-300"
            >
              <div className="relative h-80 overflow-hidden mb-6" style={{ borderRadius: '0px' }}>
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
              </div>
              
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="body-small" style={{ color: '#C9A961', textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '12px' }}>
                    {property.location}
                  </span>
                  <span className="body-small" style={{ color: '#666666', fontSize: '12px' }}>
                    {property.type}
                  </span>
                </div>
                
                <h3 className="heading-2 mb-3" style={{ fontSize: '22px' }}>{property.title}</h3>
                
                <p className="body-regular mb-4" style={{ color: '#666666', lineHeight: 1.6 }}>
                  {property.description}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t" style={{ borderColor: 'rgba(51,51,51,0.1)' }}>
                  <span className="body-small" style={{ color: '#666666' }}>{property.bedrooms} {t.properties.bedrooms}</span>
                  <span className="heading-2" style={{ fontSize: '18px', color: '#333333' }}>
                    {property.price}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Properties;